import React, { useContext, useState } from 'react';

/**
 * @typedef {{isDevMode: boolean, setDevMode: (d: boolean) => void, resetDevMode: () => void}} DevModeContext
 */


/**
 * @type  React.Context<DevModeContext>
 */
// @ts-ignore
export const DevModeContext = React.createContext(null);

export const DevModeContextProvider = ({
    children
}) => {

    const [state, setState] = useState({
        isDevMode: process.env.REACT_APP_APP_ENV === 'dev',
        setDevMode: d => setState({ ...state, isDevMode: d }),
        resetDevMode: () => {
            setState({ ...state, isDevMode: process.env.REACT_APP_APP_ENV === 'dev' })
        }
    });
    return <DevModeContext.Provider value={state}>{children}</DevModeContext.Provider>
}


export const useDevMode = () => {
    return useContext(DevModeContext)?.isDevMode;
}

export const useDevModeSetter = () => {
    return useContext(DevModeContext)?.setDevMode;
}